import { createApp } from 'vue'
import 'normalize.css'
import '@fontsource/space-grotesk/400.css'
import '@fontsource/space-grotesk/500.css'
import '@fontsource/space-grotesk/700.css'
import '@/styles/global.css'
import App from './App.vue'
import router from './router'
import { initSmoothScroll, motionDirectives, ScrollTrigger } from '@/utils/motion'

// 每次进入都从首屏开场动画开始，不恢复上次的滚动位置
// （ScrollTrigger 刷新时会还原 scrollRestoration，需通过它的接口设置）
ScrollTrigger.clearScrollMemory('manual')

initSmoothScroll()

const app = createApp(App).use(router)
Object.entries(motionDirectives).forEach(([name, dir]) => app.directive(name, dir))
app.mount('#app')

// 字体加载完成后文字尺寸会变，重新计算滚动触发位置
document.fonts && document.fonts.ready.then(() => ScrollTrigger.refresh())
